<template>
  <div>
    <el-dialog
      ref="editDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogEditForm"
        :model="dialogEditForm"
        :rules="dialogEditFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item label="省区">
                  <el-input
                    v-model="dialogEditForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="城市">
                  <el-input
                    v-model="dialogEditForm.cityName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="周期">
                  <el-input
                    v-model="dialogEditForm.period"
                    disabled
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  label="报告名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogEditForm.name"
                    maxlength="64"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="线下样本数量"
                  prop="sampleOfflineNum"
                >
                  <el-input-number
                    v-model="dialogEditForm.sampleOfflineNum"
                    :min="0"
                    :max="99999"
                    :precision="0"
                    :step="1"
                    :controls="false"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="线上样本数量"
                  prop="sampleOnlineNum"
                >
                  <el-input-number
                    v-model="dialogEditForm.sampleOnlineNum"
                    :min="0"
                    :max="99999"
                    :precision="0"
                    :step="1"
                    :controls="false"
                    style="width: 100%;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="title">
              调研零售户档位分组占比数据
            </div>
            <el-row :gutter="10">
              <el-col
                v-for="(levelItem, levelIndex) in dialogEditForm.levelProportionDtoList"
                :key="'LevelProportion_' + levelIndex"
                :span="6"
              >
                <el-form-item :label="levelItem.levelGroupName">
                  <el-input
                    v-model="levelItem.proportion"
                    maxlength="10"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="整体策略">
                  <el-input
                    v-model="dialogEditForm.overallStrategy"
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    placeholder="请输入市场整体策略内容"
                    :autosize="{ minRows: 4}"
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="风险预警">
                  <el-input
                    v-model="dialogEditForm.riskWarning"
                    type="textarea"
                    maxlength="1000"
                    show-word-limit
                    placeholder="请输入市场风险预警内容"
                    :autosize="{ minRows: 4}"
                    style="margin-top: -8px;"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            调研品规明细信息
          </h3>
          <div class="modal-row-box">
            <div
              v-for="(productItem, productIndex) in dialogEditForm.surveyProductDataList"
              :key="'ProductSurvey_' + productIndex"
            >
              <div class="title">
                {{ productItem.productName }}
              </div>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="批发价"
                    :prop="'surveyProductDataList.' + productIndex + '.wholesalePrice'"
                    :rules="dialogEditFormRules.wholesalePrice"
                  >
                    <el-input-number
                      v-model="productItem.wholesalePrice"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="最低集市交易价"
                    :prop="'surveyProductDataList.' + productIndex + '.marketMinPrice'"
                    :rules="dialogEditFormRules.marketMinPrice"
                  >
                    <el-input-number
                      v-model="productItem.marketMinPrice"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="集市交易价"
                    :prop="'surveyProductDataList.' + productIndex + '.marketPrice'"
                    :rules="dialogEditFormRules.marketPrice"
                  >
                    <el-input-number
                      v-model="productItem.marketPrice"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="环比">
                    <el-input
                      v-model="productItem.sequential"
                      maxlength="10"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="条零售价"
                    :prop="'surveyProductDataList.' + productIndex + '.orderPrice'"
                    :rules="dialogEditFormRules.orderPrice"
                  >
                    <el-input-number
                      v-model="productItem.orderPrice"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="包零售价"
                    :prop="'surveyProductDataList.' + productIndex + '.packagePrice'"
                    :rules="dialogEditFormRules.packagePrice"
                  >
                    <el-input-number
                      v-model="productItem.packagePrice"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="价格指数"
                    :prop="'surveyProductDataList.' + productIndex + '.priceIndex'"
                    :rules="dialogEditFormRules.priceIndex"
                  >
                    <el-input-number
                      v-model="productItem.priceIndex"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                      @change="handlePriceIndexChange($event, productItem)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="价格状态">
                    <el-input
                      v-model="productItem.priceIndexValue"
                      readonly
                      :class="['status-input', getPriceIndexClass(productItem.priceIndexValue)]"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  v-for="(inventoryItem, inventoryIndex) in productItem.inventoryDataArray"
                  :key="'ProductInventory_' + inventoryIndex"
                  :span="6"
                >
                  <el-form-item
                    :key="`inventory_${productIndex}_${inventoryIndex}`"
                    :label="inventoryItem.levelGroupName + ' 库存'"
                    :prop="`surveyProductDataList[${productIndex}].inventoryDataArray[${inventoryIndex}].inventory`"
                    :rules="dialogEditFormRules.inventory"
                  >
                    <el-input-number
                      v-model="inventoryItem.inventory"
                      :min="0"
                      :max="9999.99"
                      :precision="2"
                      :step="0.01"
                      :controls="false"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="动销情况：够卖"
                    :prop="'surveyProductDataList.' + productIndex + '.salesSituation1'"
                    :rules="dialogEditFormRules.salesSituation1"
                  >
                    <el-input-number
                      v-model="productItem.salesSituation1"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                      @change="handleSalesSituationChange($event, productItem, 1)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="动销情况：不够卖"
                    :prop="'surveyProductDataList.' + productIndex + '.salesSituation2'"
                    :rules="dialogEditFormRules.salesSituation2"
                  >
                    <el-input-number
                      v-model="productItem.salesSituation2"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                      @change="handleSalesSituationChange($event, productItem, 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="动销情况：卖的慢"
                    :prop="'surveyProductDataList.' + productIndex + '.salesSituation3'"
                    :rules="dialogEditFormRules.salesSituation3"
                  >
                    <el-input-number
                      v-model="productItem.salesSituation3"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                      @change="handleSalesSituationChange($event, productItem, 3)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="动销情况：卖不动"
                    :prop="'surveyProductDataList.' + productIndex + '.salesSituation4'"
                    :rules="dialogEditFormRules.salesSituation4"
                  >
                    <el-input-number
                      v-model="productItem.salesSituation4"
                      :min="0"
                      :max="9999"
                      :precision="0"
                      :step="1"
                      :controls="false"
                      style="width: 100%;"
                      @change="handleSalesSituationChange($event, productItem, 4)"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="动销情况：够卖(百分比)">
                    <el-input
                      v-model="productItem.salesSituation1Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：不够卖(百分比)">
                    <el-input
                      v-model="productItem.salesSituation2Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖的慢(百分比)">
                    <el-input
                      v-model="productItem.salesSituation3Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="动销情况：卖不动(百分比)">
                    <el-input
                      v-model="productItem.salesSituation4Ratio"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item label="市场动态">
                    <el-input
                      v-model="productItem.marketDynamicsDesc"
                      type="textarea"
                      maxlength="2000"
                      show-word-limit
                      placeholder="请输入调研品规的市场动态内容"
                      :autosize="{ minRows: 5}"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="投放建议">
                    <el-input
                      v-model="productItem.marketLaunchSuggest"
                      type="textarea"
                      maxlength="2000"
                      show-word-limit
                      placeholder="请输入调研品规的市场投放建议"
                      :autosize="{ minRows: 5}"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="库存分布健康评价">
                    <el-input
                      v-model="productItem.distributionHealth"
                      type="textarea"
                      maxlength="2000"
                      show-word-limit
                      placeholder="请输入调研品规的库存分布健康评价"
                      :autosize="{ minRows: 5}"
                      style="margin-top: -8px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-divider v-if="productIndex < dialogEditForm.surveyProductDataList.length - 1" />
            </div>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin';
import { viewMarketReportApi, updateMarketReportApi } from '@/api/v2/marketReport';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogEditForm: {},
      dialogEditFormRules: {
        name: [{ required: true, message: '请输入市场报告名称', trigger: 'blur' }],
        sampleOfflineNum: [{ required: true, message: '请输入线下样本数量', trigger: 'blur' }],
        sampleOnlineNum: [{ required: true, message: '请输入线上样本数量', trigger: 'blur' }],
        marketPrice: [{ required: true, message: '请输入调研品规的集市交易价', trigger: ['blur', 'change'] }],
        marketMinPrice: [{ required: true, message: '请输入调研品规的集市交易最低价', trigger: ['blur', 'change'] }],
        wholesalePrice: [{ required: true, message: '请输入调研品规的批发价', trigger: ['blur', 'change'] }],
        orderPrice: [{ required: true, message: '请输入调研品规的条零售价', trigger: ['blur', 'change'] }],
        packagePrice: [{ required: true, message: '请输入调研品规的包零售价', trigger: ['blur', 'change'] }],
        priceIndex: [{ required: true, message: '请输入调研品规的价格指数', trigger: ['blur', 'change'] }],
        salesSituation1: [{ required: true, message: '请输入动销情况(够卖)数量', trigger: 'blur' }],
        salesSituation2: [{ required: true, message: '请输入动销情况(不够卖)数量', trigger: 'blur' }],
        salesSituation3: [{ required: true, message: '请输入动销情况(卖的慢)数量', trigger: 'blur' }],
        salesSituation4: [{ required: true, message: '请输入动销情况(卖不动)数量', trigger: 'blur' }],
        inventory: [{ required: true, message: '请输入调研品规的库存数量', trigger: 'blur' }],
      },
      surveyProductDataList: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this

        _this.dialogEditForm = {};
        _this.surveyProductDataList = [];

        _this.loadMarketReportData();

        _this.$nextTick(() => {
          _this.$refs.dialogEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 获取市场报告数据
    loadMarketReportData() {
      let _this = this
      viewMarketReportApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        _this.dialogEditForm = {
          id: data.id,
          provinceId: data.provinceId,
          provinceName: data.provinceName,
          cityId: data.cityId,
          cityName: data.cityName,
          periodId: data.periodId,
          periodName: data.periodName,
          name: data.name,
          sampleOfflineNum: data.sampleOfflineNum,
          sampleOnlineNum: data.sampleOnlineNum,
          marketDynamics: data.marketDynamics,
          overallStrategy: data.overallStrategy,
          riskWarning: data.riskWarning,
          period: data.periodName + ' [' + data.startDate + '~' + data.endDate + ']',
          levelProportionDtoList: data.levelProportionDtoList || [],
          surveyProductDataList: data.reportPriceDtoList || [],
        }
        let inventoryDataArray = data.inventoryDtoList || [];
        // 把库存数据封装成KEY为品规ID，VALUE为各档位分组库存的MAP
        let inventoryDataMap = inventoryDataArray.reduce((acc, cur) => {
          if (!acc[cur.productId]) {
            acc[cur.productId] = []
          }
          acc[cur.productId].push(cur)
          return acc
        }, {});
        _this.dialogEditForm.surveyProductDataList.forEach((item) => {
          item.inventoryDataArray = inventoryDataMap[item.productId] || [];
        })

      })
    },
    // 价格指数变化
    handlePriceIndexChange(val, productItem) {
      productItem.priceIndexValue = '';
      if (val) {
        if (val < 100) {
          productItem.priceIndexValue = '异常';
        } else if (val < 105) {
          productItem.priceIndexValue = '低';
        } else if (val < 110) {
          productItem.priceIndexValue = '正常';
        } else if (val < 120) {
          productItem.priceIndexValue = '良好';
        } else if (val >= 120) {
          productItem.priceIndexValue = '优异';
        }
      }
    },
    // 价格指数样式
    getPriceIndexClass(value) {
      const classMap = {
        '异常': 'status-danger',
        '低': 'status-warning',
        '正常': 'status-info',
        '良好': 'status-primary',
        '优异': 'status-success'
      }
      return classMap[value] || ''
    },
    // 动销情况数量变化重新计算各类动销百分比
    handleSalesSituationChange(val, productItem, index) {
      let salesSituationTotal = 0;
      let value = val || 0;
      if (index === 1) {
        salesSituationTotal = Number(value) + Number(productItem.salesSituation2) + Number(productItem.salesSituation3) + Number(productItem.salesSituation4);
        productItem.salesSituation1Ratio = salesSituationTotal > 0 ? (value / salesSituationTotal * 100).toFixed(1) + '%' : '0%';
      } else if (index === 2) {
        salesSituationTotal = Number(value) + Number(productItem.salesSituation1) + Number(productItem.salesSituation3) + Number(productItem.salesSituation4);
        productItem.salesSituation2Ratio = salesSituationTotal > 0 ? (value / salesSituationTotal * 100).toFixed(1) + '%' : '0%';
      } else if (index === 3) {
        salesSituationTotal = Number(value) + Number(productItem.salesSituation1) + Number(productItem.salesSituation2) + Number(productItem.salesSituation4);
        productItem.salesSituation3Ratio = salesSituationTotal > 0 ? (value / salesSituationTotal * 100).toFixed(1) + '%' : '0%';
      } else if (index === 4) {
        salesSituationTotal = Number(value) + Number(productItem.salesSituation1) + Number(productItem.salesSituation2) + Number(productItem.salesSituation3);
        productItem.salesSituation4Ratio = salesSituationTotal > 0 ? (value / salesSituationTotal * 100).toFixed(1) + '%' : '0%';
      }
    },
    // 保存
    handleSave() {
      let _this = this;
      _this.$refs.dialogEditForm.validate((valid) => {
        if (valid) {
          _this.$confirm('是否确定保存修改后的市场报告数据', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.dialogEditForm.levelProportionData = JSON.stringify(_this.dialogEditForm.levelProportionDtoList);
            _this.dialogEditForm.reportPriceData = JSON.stringify(_this.dialogEditForm.surveyProductDataList);

            updateMarketReportApi(_this.dialogEditForm).then(() => {
              _this.$message({ message: '保存成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose() {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogEditForm.clearValidate()
    },
  }
}
</script>
<style lang="scss" scoped>
.divider-title {
  p {
    color: #409eff;
  }
}

.title {
  font-size: 14px;
  font-weight: 800;
  color: #409eff;
  margin: 8px 0;
}

.status-input {
  &.status-danger {
    ::v-deep .el-input__inner {
      color: #f56c6c;
      font-weight: bold;
    }
  }
  &.status-warning {
    ::v-deep .el-input__inner {
      color: #e6a23c;
      font-weight: bold;
    }
  }
  &.status-info {
    ::v-deep .el-input__inner {
      color: #4a4c4c;
    }
  }
  &.status-primary {
    ::v-deep .el-input__inner {
      color: #409eff;
      font-weight: bold;
    }
  }
  &.status-success {
    ::v-deep .el-input__inner {
      color: #67c23a;
      font-weight: bold;
    }
  }
}
</style>
